<template>
  <div>
    <div v-if="$i18n.locale === 'pe'">
      <Message message="" icon="coming_soon_cl.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'br'">
      <Message message="" icon="coming_soon_br.svg" :as-card="true" />
    </div>
    <div v-if="['cl'].includes($i18n.locale)" id="portfolios-container">
      <div id="portfolios-content" class="card-item mt-6">
        <operation-list
          id="operation-list" />
      </div>
    </div>
  </div>
</template>
<script>
import OperationList from '@/ui/views/internal/my-portfolios/OperationList.vue';
import Message from '@/ui/components/Message.vue';

export default {
  name: 'MyPortfolios',
  components: { OperationList, Message },
  data() {
    return { };
  }
};
</script>
<style scoped>
#portfolios-container {
  margin-top: 2rem;
  overflow: visible !important;
}
</style>
